import { z } from "zod";
export const notificationTypeEnum = z.enum([
    "CASE_SUSPENDED",
    "APPLICATION_RECEIVED",
    "APPLICATION_UNDER_REVIEW",
    "APPLICATION_APPROVED",
    "APPLICATION_REJECTED",
    "APPLICATION_MATCHED",
]);
/**
 * 通知 payload（表示用スナップショット）の discriminated union。
 *
 * - 案件停止 (`CASE_SUSPENDED`) / 応募ステータス系: `caseTitle` のみ。
 * - 新着応募 (`APPLICATION_RECEIVED`) / マッチング成立 (`APPLICATION_MATCHED`): `caseTitle` + 応募元組織名。
 *
 * **PII 方針**: 通知先が本来可視な値のみを格納する。`applicantOrganizationName` は
 * `Application.organizationName`（企業に可視）に限定し、応募者個人名・連絡先は載せない。
 * 詳細は spec/backend/notification/design.md §3。
 */
export const notificationPayloadSchema = z.discriminatedUnion("type", [
    z.object({ type: z.literal("CASE_SUSPENDED"), caseTitle: z.string() }),
    z.object({
        type: z.literal("APPLICATION_RECEIVED"),
        caseTitle: z.string(),
        applicantOrganizationName: z.string(),
    }),
    z.object({ type: z.literal("APPLICATION_UNDER_REVIEW"), caseTitle: z.string() }),
    z.object({ type: z.literal("APPLICATION_APPROVED"), caseTitle: z.string() }),
    z.object({ type: z.literal("APPLICATION_REJECTED"), caseTitle: z.string() }),
    // 連絡先そのものは載せない（PII 最小化）。連絡先は案件ページで権限判定のうえ表示する。
    z.object({
        type: z.literal("APPLICATION_MATCHED"),
        caseTitle: z.string(),
        applicantOrganizationName: z.string(),
    }),
]);
/** ベル一覧のクエリ（page/pageSize はアプリ共通のオフセット方式）。 */
export const notificationListQuerySchema = z.object({
    // true のとき未読のみ返す。`z.coerce.boolean()` は "false" も true になるため明示的に解釈する。
    unreadOnly: z
        .union([z.boolean(), z.literal("true"), z.literal("false")])
        .transform((v) => v === true || v === "true")
        .optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
